import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export function ImpressumPage() {
  const { t } = useLanguage();

  return (
    <div className="bg-white">
      <div className="max-w-3xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-extrabold text-gray-900">
          {t('impressum.title')}
        </h1>
        
        <div className="mt-8 prose prose-blue">
          <h2 className="font-bold text-gray-800">{t('impressum.companyDetails.title')}</h2>
          <p>
            Asena UG (haftungsbeschränkt)<br />
            {t('impressum.companyDetails.address')}<br />
            22041, Hamburg<br />
            Deutschland
          </p>

          <h2 className="font-bold text-gray-800">{t('impressum.contact.title')}</h2>
          <p>
            {t('impressum.contact.phone')}: +49 (0) 40 37 6129 52<br />
            {t('impressum.contact.email')}: info@asena-ug.de
          </p>

          <h2 className="font-bold text-gray-800">{t('impressum.registration.title')}</h2>
          <p>
            {t('impressum.registration.court')}: Amtsgericht Hamburg<br />
            {t('impressum.registration.number')}: HRB 145270<br />
            {t('impressum.registration.vatId')}: DE406464075
          </p>

          <h2 className="font-bold text-gray-800">{t('impressum.management.title')}</h2>
          <p>{t('impressum.management.content')}</p>

          <h2 className="font-bold text-gray-800">{t('impressum.responsibility.title')}</h2>
          <p>{t('impressum.responsibility.content')}</p>
        </div>
      </div>
    </div>
  );
}